import { Avatar, Button } from '@mantine/core';
import styled from 'styled-components';

const ArrowedButton = ({ title, onClick }: any) => {
  return (
    <>
      <Button
        leftSection={
          <Avatar src="/assets/addIconWhite.png" alt="button-icon" size="24" />
        }
        radius="10px"
        onClick={onClick}
        color={'#5C26FF'}
        style={{
          width: 'max-content',
          height: '44px',
        }}
      >
        <ButtonLabel>{title}</ButtonLabel>
      </Button>
    </>
  );
};
export default ArrowedButton;

const ButtonLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
`;
